<template>
    <div class="date-update-wrapper">
        <a-modal
            class="date-update"
            :visible="visible"
            :title="form.getFieldValue('id') ? `${$t('web.modify' /* 修改 */)}${$t('web.date' /* 日期 */)}` : `${$t('web.add' /* 添加 */)}${$t('web.date' /* 日期 */)}`"
            :width="500"
            :maskClosable="false"
            :confirm-loading="confirmLoading"
            @ok="handleOk"
            @cancel="handleCancel"
        >
            <a-form :form="form">
                <a-form-item class="mb10" :hidden="true">
                    <a-input v-decorator="['id']"></a-input>
                </a-form-item>
                <a-form-item class="mb10" :label="$t('program.meeting_date' /* 会议日期 */)">
                    <a-date-picker
                        v-decorator="['meeting_date', { rules: [{ required: true, message: $t('formConfig.please_select' /* 请选择 */) + $t('program.batch_live_label_date') }] }]"
                        :placeholder="$t('formConfig.please_select' /* 请选择 */) + $t('program.batch_live_label_date')"
                    />
                </a-form-item>
                <a-form-item :extra="$t('program.current_date_color' /* 当前日期的日程颜色 */)" :label="$t('program.schedule_color' /* 日程颜色 */)">
                    <color-picker
                        v-decorator="['date_color', { rules: [{ required: true, message: $t('formConfig.please_select' /* 请选择 */) + $t('program.schedule_color' /* 日程颜色 */) }] }]"
                    ></color-picker>
                </a-form-item>
            </a-form>
        </a-modal>
    </div>
</template>
<script>
import pick from 'lodash.pick';
import moment from 'moment';
import ColorPicker from '@/components/ColorPicker';
const fileds = ['meeting_date', 'id', 'date_color'];

export default {
    name: 'DateUpdateModal',
    components: { ColorPicker },
    data() {
        return {
            visible: false,
            confirmLoading: false,
            form: this.$form.createForm(this)
        };
    },
    methods: {
        show(data) {
            this.visible = true;
            if (data && data.id) {
                this.$nextTick(() => {
                    this.form.setFieldsValue(pick(data, fileds));
                });
            }
        },
        handleOk() {
            this.form.validateFields((err, values) => {
                if (!err) {
                    this.confirmLoading = true;
                    values.date_id = values.id;
                    delete values.id;
                    values.meeting_date = values.meeting_date ? moment(values.meeting_date).format('YYYY-MM-DD') : '';
                    this.$request
                        .post({ url: 'addEditDate', data: values })
                        .then(res => {
                            this.$message.success(this.form.getFieldValue('id') ? this.$t('web.modify_success' /* 修改成功 */) : this.$t('web.add_success' /* 添加成功 */));
                            this.confirmLoading = false;
                            this.$emit('closeDateUpdate');
                            this.handleCancel();
                        })
                        .finally(() => {
                            this.confirmLoading = false;
                        });
                }
            });
        },
        handleCancel() {
            this.form.resetFields();
            this.visible = false;
        }
    }
};
</script>
<style lang="less" scoped>
::v-deep .ant-calendar-picker {
    width: 100%;
}
</style>
